var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.organization)?_c('router-link',{staticClass:"table-item-preview",attrs:{"to":{ name: 'OrganizationEdit', params: { id: _vm.organization._id, } }}},[_c('p',[_vm._v(_vm._s(_vm.organization.name))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }